import { fetchWithHandledResponse, generatePostHeaders } from '../helpers';

import { DEFAULT_PAGE_SIZE } from '../constants';
import { apiUrl } from 'config';
import { createMermaidDefinition } from '../helpers/QuestionnaireHelper';
import mermaid from 'mermaid';

export const fetchAnalysis = () => {
    return fetchWithHandledResponse(`${apiUrl}/analysis`);
};

export const saveAnalysis = analysis => {
    return fetchWithHandledResponse(`${apiUrl}/analysis/save`, {
        method: 'post',
        headers: generatePostHeaders(analysis),
        body: JSON.stringify(analysis),
    }).then(() => {
        return analysis; // necessary for rewind
    });
};

export const fetchAnalyses = (
    search = null,
    status = null,
    pageNumber = 1,
    pageSize = DEFAULT_PAGE_SIZE
) => {
    let url = `${apiUrl}/analyses?pageNumber=${pageNumber}&pageSize=${pageSize}`;

    // Encoded, or a term containing & # + or % is either truncated or silently altered on the way
    // to the API -- 'A & B' arrived as 'A ' with a stray 'B' parameter.
    if (search) {
        url += `&search=${encodeURIComponent(search)}`;
    }

    if (status) {
        url += `&status=${encodeURIComponent(status)}`;
    }

    return fetchWithHandledResponse(url);
};

export const fetchAnalysisAuditById = analysisId => {
    return fetchWithHandledResponse(`${apiUrl}/analysis/${analysisId}/review`);
};

export const suspendAnalysis = (analysisId, reason) => {
    return fetchWithHandledResponse(`${apiUrl}/analysis/suspend`, {
        method: 'post',
        body: JSON.stringify({
            analysisId,
            reason,
        }),
    });
};

export const fetchAnalysisCompleteUserStats = (
    startDate = null,
    endDate = null,
    pageNumber = 1,
    pageSize = DEFAULT_PAGE_SIZE
) => {
    let queryParams = `?pageNumber=${pageNumber}&pageSize=${pageSize}`;

    if (startDate) queryParams += '&startDate=' + startDate;

    if (endDate) queryParams += '&endDate=' + endDate;

    return fetchWithHandledResponse(`${apiUrl}/analysis/user-stats${queryParams}`);
};

export const patchAnalysisReview = propertiesToPatch => {
    return fetchWithHandledResponse(`${apiUrl}/analysis/review`, {
        method: 'PATCH',
        body: JSON.stringify(propertiesToPatch),
    });
};

export const deleteAnalysis = analysisId => {
    return fetchWithHandledResponse(`${apiUrl}/analysis/${analysisId}`, {
        method: 'delete',
    });
};

export const fetchCurrentAnalysisStats = () => {
    return fetchWithHandledResponse(`${apiUrl}/analysis/current-stats`);
};

export const createQuestionMap = (questions, containerId) => {
    return new Promise((resolve, reject) => {
        createMermaidDefinition(questions).then(async data => {
            if (data) {
                const { svg } = await mermaid.render(containerId, data);
                if (svg) {
                    resolve(svg);
                } else {
                    reject('Unable to render question map');
                }
            } else {
                reject('Unable to create question map definition');
            }
        });
    });
};
